<template>
  <div class="statistics">
    <div class="text">
      <div class="monitor-header">作业票</div>
      <div class="monitor-text">
        <div class="monitor-table">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="tableTouStyle" height="100%">
            <el-table-column align="center" prop="workNum" label="作业编号 "  type="index" width="60"/>
            <el-table-column align="center" prop="workName" label="作业名称" width="180" />
            <el-table-column align="center" prop="classifyName" label="作业分类" width="180" />
            <el-table-column align="center" prop="organization" label="作业单位" />
            <el-table-column align="center" prop="rateOfProgress" label="进度" />
            <el-table-column align="center" prop="workPlace" label="作业地点" />
          </el-table>
          <list-page ref="page" :total="totalNum" @chileByCurrentPage="chileByCurrentPage($event)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWork } from "@/api/worker.js";
import ListPage from './list_main_page'

export default {
  name: "Gaojing",
  components: {
    ListPage
  },
  data() {
    return {
      drawer: true,
      activeName: "1",
      totalNum: null,
      curPage: 1,
      limit: 10,
      // 表格头部样式
      tableTouStyle: {
        background: '#f1f1f1',
        color: '#000',
        'font-size': '14px',
        'text-align': 'center'
      },
      tableData: []
    };
  },
  props: {
    msg: String,
  },
  created() {
    this.getListData()
  },
  mounted() {
  },
  methods: {
    // 子组件传给父组件的分页参数
    chileByCurrentPage(val) {
      this.$nextTick(function() {
        this.curPage = val
      })
    },
    getListData() {
      getWork(this.curPage, this.limit).then(res => {
        const result = res.data
        if(result.status_code === 100) {
          this.totalNum = result.pageTotal
          this.tableData = result.data
        }
      })
    },
  },
};
</script>

<style scoped>
.statistics {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 15%;
  left: 20%;
}
.text {
  width: 60%;
  height: 60%;
  color: #000;
  background: #fff;
}
.monitor-text{
  height: calc(100% - 40px);
  padding: 20px 20px 0 20px;
}
.monitor-header {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #f5f5f5;
}
.monitor-table {
  width: 100%;
  height: calc(100% - 60px);
}
</style>